import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import LoginModal from './LoginModal';
import logoApp from '../assets/logo-app.png';
import iconStreak from '../assets/icon-streak.svg';
import iconArrowRight from '../assets/icon-arrow-right.svg';
import iconFire from '../assets/icon-fire.svg';
import iconTarget from '../assets/icon-target.svg';
import iconTrophy from '../assets/icon-trophy.svg';
import iconUsers from '../assets/icon-users.svg';
import iconSmartphone from '../assets/icon-smartphone.svg';
import iconThreads from '../assets/icon-threads.svg';
import iconFacebook from '../assets/icon-facebook.svg';
import iconInstagram from '../assets/icon-instagram.svg';
import iconMail from '../assets/icon-mail.svg';

function LandingPage() {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="landing-page">
      {/* Navigation Bar */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logoApp} alt="Runstreak Dashboard" className="nav-logo" />
            <span className="nav-brand-text">Runstreak Dashboard</span>
          </div>
          <div className="nav-menu">
            <a href="#features" className="nav-link">Features</a>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <Link to="/help" className="nav-link">Help</Link>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-outlined">Login</button>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-primary">Get Started</button>
          </div>
        </div>
      </nav>

      {/* Login Modal */}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="badge">
              <img src={iconStreak} alt="" />
              <span>Keep Your Streak Alive</span>
            </div>
            <h1>Never Miss a Run Again</h1>
            <p className="hero-description">
              Build unbreakable running habits with streak tracking, social motivation, and achievement rewards. Join thousands of runners staying consistent every day.
            </p>
          </div>

          <div className="hero-stats-card">
            <div className="current-streak">
              <h2>47</h2>
              <div className="streak-label">
                <img src={iconFire} alt="" />
                <span>Day Streak</span>
              </div>
            </div>
            <div className="quick-stats">
              <div className="stat-row">
                <span>This Week</span>
                <strong>5 runs</strong>
              </div>
              <div className="stat-row">
                <span>Best Pace</span>
                <strong>4:58/km</strong>
              </div>
              <div className="stat-row">
                <span>Friends Active</span>
                <strong>12 online</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-header">
          <h2>Why Runners Choose Runstreak Dashboard</h2>
          <p>Powerful features designed to keep you motivated and consistent in your running journey.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <img src={iconTarget} alt="" />
            <h3>Streak Tracking</h3>
            <p>Never break your running chain. Visual streak counter with motivational reminders.</p>
          </div>

          <div className="feature-card">
            <img src={iconTrophy} alt="" />
            <h3>Achievement System</h3>
            <p>Unlock badges and celebrate milestones as you progress in your running journey.</p>
          </div>

          <div className="feature-card">
            <img src={iconUsers} alt="" />
            <h3>Social Community</h3>
            <p>Connect with fellow runners, share achievements, and motivate each other.</p>
          </div>

          <div className="feature-card">
            <img src={iconSmartphone} alt="" />
            <h3>Cross-Platform</h3>
            <p>Seamlessly sync between mobile app and web dashboard for complete flexibility.</p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stat-item">
          <h3>21 Days</h3>
          <p>Build Lasting Habits</p>
        </div>
        <div className="stat-item">
          <h3>100%</h3>
          <p>Strava Integration</p>
        </div>
        <div className="stat-item">
          <h3>Free</h3>
          <p>Forever Access</p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Start Your Streak?</h2>
        <p>Start tracking your running streak today and build unbreakable habits. Free forever, seamlessly integrated with Strava.</p>
        <div className="cta-buttons">
          <button onClick={() => setShowLoginModal(true)} className="btn btn-primary">
            Get Started Free
            <img src={iconArrowRight} alt="" />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-brand">
              <img src={logoApp} alt="Runstreak Dashboard" className="brand-logo" />
              <span>Runstreak Dashboard</span>
            </div>
            <p>Keep your running streak alive with the most motivational fitness app.</p>
            <div className="social-links">
              <a href="#threads"><img src={iconThreads} alt="Threads" /></a>
              <a href="#facebook"><img src={iconFacebook} alt="Facebook" /></a>
              <a href="#instagram"><img src={iconInstagram} alt="Instagram" /></a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="#features">Features</a></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><a href="#download">Download</a></li>
              <li><a href="#updates">Updates</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Contact Us</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Bug Reports</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Feature Requests</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Careers</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2025 Runstreak. All rights reserved.</p>
          <div className="footer-contact">
            <img src={iconMail} alt="" />
            <a href="mailto:hello@runstreakdashboard.com">hello@runstreakdashboard.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
